import * as helper from "./../../../Assets/Js/helper";
import { IPaytourOptions } from "../../../Assets/Js/paytour/PaytourHelperClass";

export async function PaytourHandler() {
	const $wrapper = helper.$("#wrapper");
	const extender = helper.getData($wrapper, "extend");
	const ab1 = parseInt(helper.getData($wrapper, "ab1"));
	const ab4 = parseInt(helper.getData($wrapper, "ab4"));
	const ab6 = parseInt(helper.getData($wrapper, "ab6"));
	const mode: "so" | "vx" = helper.getData($wrapper, "mode");
	const coupon: string = helper.getData($wrapper, "coupon");
	const signupUrl = helper.getData($wrapper, "signupurl");
	const targetUrl = helper.getData($wrapper, "targeturl");
	const loginButton = document.querySelector(".header-buttons-login");
	const isVxWorld = window.location.host.match(/visit-x\.world/) !== null;

	const Paytour = (window as any).paytourHelper;
	let PaytourSettings: IPaytourOptions = {
		targetUrl: "https://sexole.com/es/",
		successUrl: "https://sexole.com/es/",
		pfm: 1502,
		pfmsub: "sexolecom",
		host: 0,
		lang: "es",
		hideClose: false,
		minAmount: 2500, // cents
		disableJump: true,
		option: coupon,
		conversion: {
			signup: {
				background: "https://www.visit-x.net/assets/img/signup/sexole/sexole_desktop.png",
				backgroundMobile: "https://www.visit-x.net/assets/img/signup/sexole/sexole_desktop.png",
			},
		},
	};

	if (mode === "vx") {
		PaytourSettings = {
			lpId: "SexoleStartVX",
			hideSignupConfirmation: true,
			targetUrl: "https://visit-x.es/es/",
			successUrl: "https://visit-x.es/es/",
			pfm: 1502,
			host: 0,
			lang: "es",
			hideClose: false,
			minAmount: 2500, // cents
			disableJump: true,
			option: coupon,
		};
	}

	let links;
	if (ab6 === 1) {
		links = $wrapper.querySelectorAll(".paytour, .nav a, button");
	} else if (ab4 === 0) {
		links = $wrapper.querySelectorAll(".paytour");
	} else {
		links = $wrapper.querySelectorAll(".paytour, a, button");
	}

	links.forEach((link) => {
		if (!helper.hasClass(link, "nopaytour")) {
			if (isVxWorld && link === loginButton) {
				helper.addClickListener(loginButton, (evt: MouseEvent) => {
					evt.preventDefault();
					if (mode === "vx") {
						window.location.href = "https://visit-x.es/es/?vxpAutoFlow=Login&" + extender;
					} else {
						window.location.href = "https://sexole.com/es/?vxpAutoFlow=Login&" + extender;
					}
				});
			} else {
				helper.addEventListener(link, "click", (evt: MouseEvent) => {
					evt.preventDefault();
					if (ab1 === 3) {
						window.location = signupUrl;
					} else if (ab1 === 2) {
						window.location = targetUrl;
					} else if (ab1 === 1) {
						Paytour.openSignup(PaytourSettings);
					} else {
						Paytour.openPaytour(PaytourSettings);
					}
				});
			}
		}
	});
}
